import { render, staticRenderFns } from "./order.vue?vue&type=template&id=7c2fe934&scoped=true&"
import script from "./order.vue?vue&type=script&lang=js&"
export * from "./order.vue?vue&type=script&lang=js&"
import style0 from "./order.vue?vue&type=style&index=0&id=7c2fe934&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c2fe934",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\project\\uniFrame\\uni-frame\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c2fe934')) {
      api.createRecord('7c2fe934', component.options)
    } else {
      api.reload('7c2fe934', component.options)
    }
    module.hot.accept("./order.vue?vue&type=template&id=7c2fe934&scoped=true&", function () {
      api.rerender('7c2fe934', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/route/order.vue"
export default component.exports